<!--
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-07-21 11:19:04
 * @LastEditTime: 2024-04-19 16:44:04
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <div
            :style="{
                height: $route.name === 'login' ? '100vh' : 'calc(100vh - 60px)'
            }"
            class="container"
        >
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
        </div> -->
    <!-- <div v-show="$route.name !== 'login'" class="nav">
      <van-icon name="arrow-left" style="margin-right: 80px" @click="back" />
      <van-icon name="arrow" @click="forward" />
    </div> -->
  </div>
</template>

<script>
import { isWeiXin } from '@/utils/getWx';
export default {
  name: 'App',
  methods: {
    back() {
      this.$router.go(-1);
    },
    forward() {
      // if (isWeiXin()) {
      //   console.log(wx.miniProgram);
      //   wx.miniProgram.postMessage({ data: '123' });
      //   wx.miniProgram.getEnv((res) => {
      //     if (res.miniprogram) {
      //       this.isMiniProgram = true;
      //     }
      //   });
      // }
      this.$router.go(1);
    }
  }
};
</script>

<style lang="stylus">
body, html {
  width: 100%;

  .van-toast {
    z-index: 100000 !important;
  }

  .van-image-preview {
    // z-index: 99998!important;
  }
}

#app {
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  // position: relative;
  // height: calc(100vh - 60px);
  // overflow: auto;
}

.nav {
  width: 100%;
  position: fixed;
  bottom: 0px;
  text-align: center;
  background-color: #fff;
  line-height: 40px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue